import React from "react";
import { Line, Text } from "@react-three/drei";
import { getLetter } from "../helpers"; // Importamos la función para obtener las letras

const Grid = ({ gridPoints, floors, selectedFloor, heightMatrix, selectedSpacing, setSelectedSpacing, setSelectedAxesSpacing }) => 
{  
  if (!gridPoints || gridPoints.length === 0 || !heightMatrix || heightMatrix.length === 0) {
    return null; // No renderizar si falta información
  }

  const lines = [];
  const labels = [];
  const measures = [];

  const lineColorBase = "#B0B0B0";
  const lineColorSelected = "#FF6666";

  const uniqueX = [...new Set(gridPoints
      .map((p) => parseFloat(p.x))
      .filter((x) => !isNaN(x))
    )].sort((a, b) => a - b);

  const uniqueZ = [...new Set(gridPoints
    .map((p) => parseFloat(p.z))
    .filter((z) => !isNaN(z))
    )].sort((a, b) => a - b);


  // Función para calcular la altura acumulada de los pisos
  const getFloorHeight = (floor) => 
  {
    return heightMatrix.slice(0, floor).reduce((acc, curr) => acc + parseFloat(curr.height), 0);
  };

  for (let floor = 0; floor <= floors; floor++) 
  {
    let lineColor = floor === selectedFloor ? lineColorSelected : lineColorBase;
    let lineWidth = floor === selectedFloor ? 2 : 1;
    let opacity = floor === selectedFloor ? 0.9 : 0.4;
    const floorHeight = getFloorHeight(floor);   

    // Líneas en el eje X
    for (let i = 0; i < uniqueX.length; i++) 
    {
      let xo = parseFloat(uniqueX[i]);
      let xf = parseFloat(uniqueX[i + 1]);

      lines.push(
        <Line
          key={`x-lines-${floor}-${xo}-${Math.random(0,1000) }`}
          points={[
            [xo, floorHeight, uniqueZ[0]],
            [xo, floorHeight, uniqueZ[uniqueZ.length - 1]],
          ]}
          color={lineColor}
          lineWidth={lineWidth}
          opacity={opacity}
          transparent={true}
        />
      );

      if (floor === 0) 
      {
        labels.push(
          <Text
            key={`x-text-${floor}-${xo}-${Math.random(0,1000) }`}
            position={[xo, 0.5, uniqueZ[0] - 1]}
            fontSize={1}
            color="black"
            anchorX="center"
            anchorY="middle"
          >
            {getLetter(i)}
          </Text>
        );
      }      

      if (floor === 0 && !isNaN(xf)) 
      {
        measures.push(
          <Text
            key={`x-measures-${floor}-${xo}-${Math.random(0,1000) }`}
            position={[xo + (xf - xo) / 2, 0.5, uniqueZ[0] - 1]}
            fontSize = {selectedSpacing === `${getLetter(i)}1 - ${getLetter(i + 1)}1` ?  0.9 :  0.5}
            color = {selectedSpacing === `${getLetter(i)}1 - ${getLetter(i + 1)}1` ?  "#1e2222" : "#1142e8"}
            anchorX="center"
            anchorY="middle"
            onClick={() => {setSelectedSpacing(`${getLetter(i)}1 - ${getLetter(i + 1)}1`); setSelectedAxesSpacing([getLetter(i),  getLetter(i+1), 'Z' ])}}
          >
            {parseFloat(xf - xo).toFixed(2)}
          </Text>
        );
      }
    }
    
    // Líneas en el eje Z
    for (let i = 0; i < uniqueZ.length; i++) 
    {
      let zo = parseFloat(uniqueZ[i]);
      let zf = parseFloat(uniqueZ[i + 1]);

      lines.push(
        <Line
          key={`z-lines-${floor}-${zo}-${Math.random(0,1000) }`}
          points={[
            [uniqueX[0], floorHeight, zo],
            [uniqueX[uniqueX.length - 1], floorHeight, zo],
          ]}
          color={lineColor}
          lineWidth={lineWidth}
          opacity={opacity}
          transparent={true}
        />
      );

      if (floor === 0) 
      {
        labels.push(
          <Text
            key={`z-text-${floor}-${zo}-${Math.random(0,1000) }`}
            position={[uniqueX[0] - 1, 0.5, zo]}
            fontSize={1}
            color="black"
            anchorX="center"
            anchorY="middle"
          >
            {i + 1}
          </Text>
        );
      }

      if (floor === 0 && !isNaN(zf))
      {
        measures.push(
          <Text
            key={`z-measures-${floor}-${zo}-${Math.random(0,1000) }`}
            position={[uniqueX[0] - 1, 0.5, zo + (zf - zo) / 2]}
            fontSize = {selectedSpacing === `${getLetter(0)}${i + 1} - ${getLetter(0)}${i + 2}` ?  0.9 :  0.5}
            color = {selectedSpacing === `${getLetter(0)}${i + 1} - ${getLetter(0)}${i + 2}` ?  "#1e2222" :  "#1142e8"}
            anchorX="center"
            anchorY="middle"
            onClick={() => {setSelectedSpacing(`${getLetter(0)}${i + 1} - ${getLetter(0)}${i + 2}`); setSelectedAxesSpacing([i + 1,i + 2, "X" ])} }
          >
            {parseFloat(zf - zo).toFixed(2)}
          </Text>
        );
      }
    }
   
    lineColor = floor === selectedFloor - 1 ? lineColorSelected : lineColorBase;
    lineWidth = floor === selectedFloor - 1 ? 2 : 1;
    opacity = floor === selectedFloor -1 ? 0.9 : 0.4;
    // Columnas (líneas verticales)
    if (floor < floors) 
    {
      gridPoints.forEach(({ x, z }) => 
      {
        if (typeof heightMatrix[floor] === 'undefined') 
        {
          return;  // Salir de la iteración actual si el valor es undefined
        }
        
        lines.push(
          <Line
            key={`z-columns-${floor}-${Math.random(0,1000) }`}
            points={[
              [x, floorHeight, z],
              [x, floorHeight + parseFloat(heightMatrix[floor].height), z],
            ]}
            color={lineColor}
            lineWidth={lineWidth}
            opacity={opacity}
            transparent={true}
          />
        );
      });
    }
  }

  return <>{[...lines, ...labels, ...measures]}</>;
};

export default Grid;